import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const desligamentoProfissionalRoutes: Routes = [
  {
    path: 'desligamento-profissional',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./desligamento-profissional.component').then(
            (m) => m.DesligamentoProfissionalComponent,
          ),
        data: {
          title: 'Solicitação de Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_PROFISSIONAL_CONSULTAR],
          breadcrumb: [{ label: 'Desligamento', url: '/desligamento-profissional' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./desligamento-form/desligamento-form.component').then(
            (m) => m.DesligamentoFormComponent,
          ),
        data: {
          title: 'Solicitar Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_PROFISSIONAL_CADASTRAR, Role.DESLIGAMENTO_GESTOR_CADASTRAR],
          breadcrumb: [
            { label: 'Desligamento', url: '/desligamento-profissional' },
            { label: 'Cadastrar', url: '/desligamento-profissional/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./desligamento-form/desligamento-form.component').then(
            (m) => m.DesligamentoFormComponent,
          ),
        data: {
          title: 'Editar Solicitação de Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_PROFISSIONAL_EDITAR],
          breadcrumb: [
            { label: 'Desligamento', url: '/desligamento-profissional' },
            { label: 'Editar', url: '/desligamento-profissional/editar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./desligamento-form/desligamento-form.component').then(
            (m) => m.DesligamentoFormComponent,
          ),
        data: {
          title: 'Visualizar Solicitação de Desligamento do Profissional',
          roles: [
            Role.DESLIGAMENTO_PROFISSIONAL_CONSULTAR,
            Role.DESLIGAMENTO_GESTOR_VALIDAR,
            Role.DESLIGAMENTO_GESTOR_CADASTRAR,
          ],
          breadcrumb: [
            { label: 'Desligamento', url: '/desligamento-profissional' },
            { label: 'Visualizar', url: '/desligamento-profissional/visualizar' },
          ],
        },
      },
      {
        path: 'gestor',
        loadComponent: () =>
          import('./desligamento-gestor/desligamento-gestor.component').then(
            (m) => m.DesligamentoGestorComponent,
          ),
        data: {
          title: 'Desligamento de Profissional - Visão Gestor',
          roles: [
            Role.DESLIGAMENTO_GESTOR_CONSULTAR,
            Role.DESLIGAMENTO_GESTOR_CADASTRAR,
            Role.DESLIGAMENTO_GESTOR_VALIDAR,
          ],
          breadcrumb: [{ label: 'Desligamento (Gestor)', url: '/desligamento-profissional/gestor' }],
        },
      },
      {
        path: 'gestor/solicitar',
        loadComponent: () =>
          import('./desligamento-gestor-multiplo/desligamento-gestor-multiplo.component').then(
            (m) => m.DesligamentoGestorMultiploComponent,
          ),
        data: {
          title: 'Solicitar Desligamento - Gestor',
          roles: [Role.DESLIGAMENTO_GESTOR_CADASTRAR],
          breadcrumb: [
            { label: 'Desligamento (Gestor)', url: '/desligamento-profissional/gestor' },
            { label: 'Solicitar Desligamento' },
          ],
        },
      },
      {
        path: 'validar/:id',
        loadComponent: () =>
          import('./desligamento-validar/desligamento-validar.component').then(
            (m) => m.DesligamentoValidarComponent,
          ),
        data: {
          title: 'Analisar Solicitação de Desligamento',
          roles: [Role.DESLIGAMENTO_GESTOR_VALIDAR],
          breadcrumb: [
            { label: 'Desligamento (Gestor)', url: '/desligamento-profissional/gestor' },
            { label: 'Analisar' },
          ],
        },
      },

      // HU069 — Coordenação Nacional
      {
        path: 'coordenacao',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-coordenacao.component').then(
            (m) => m.DesligamentoCoordenacaoComponent,
          ),
        data: {
          title: 'Consultar Solicitações de Desligamento - Coordenação Nacional',
          roles: [Role.DESLIGAMENTO_CN_CONSULTAR],
          breadcrumb: [{ label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' }],
        },
      },
      {
        path: 'coordenacao/analisar/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-analise-form/desligamento-analise-form.component').then(
            (m) => m.DesligamentoAnaliseFormComponent,
          ),
        data: {
          title: 'Analisar Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_CN_ANALISAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Analisar' },
          ],
        },
      },
      {
        path: 'coordenacao/corrigir-data/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-correcao-data/desligamento-correcao-data.component').then(
            (m) => m.DesligamentoCorrecaoDataComponent,
          ),
        data: {
          title: 'Editar Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_CN_ANALISAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Editar' },
          ],
        },
      },
      {
        path: 'coordenacao/editar/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-analise-form/desligamento-analise-form.component').then(
            (m) => m.DesligamentoAnaliseFormComponent,
          ),
        data: {
          title: 'Editar Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_CN_ANALISAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Editar' },
          ],
        },
      },
      {
        path: 'coordenacao/visualizar/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-cn-visualizar/desligamento-cn-visualizar.component').then(
            (m) => m.DesligamentoCnVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_CN_CONSULTAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Visualizar' },
          ],
        },
      },
      {
        path: 'coordenacao/desfazer/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-desfazer-form/desligamento-desfazer-form.component').then(
            (m) => m.DesligamentoDesfazerFormComponent,
          ),
        data: {
          title: 'Desfazer Desligamento do Profissional',
          roles: [Role.DESLIGAMENTO_CN_CANCELAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Desfazer Desligamento' },
          ],
        },
      },
      {
        path: 'coordenacao/cancelar/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-desfazer-form/desligamento-desfazer-form.component').then(
            (m) => m.DesligamentoDesfazerFormComponent,
          ),
        data: {
          title: 'Cancelar Desligamento',
          roles: [Role.DESLIGAMENTO_CN_CANCELAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Cancelar', url: '' },
          ],
        },
      },
      {
        path: 'coordenacao/reverter/:id',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-desfazer-form/desligamento-desfazer-form.component').then(
            (m) => m.DesligamentoDesfazerFormComponent,
          ),
        data: {
          title: 'Reverter Desligamento',
          roles: [Role.DESLIGAMENTO_CN_REVERTER],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Reverter', url: '' },
          ],
        },
      },
      {
        path: 'coordenacao/multiplo',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-multiplo/desligamento-multiplo.component').then(
            (m) => m.DesligamentoMultiploComponent,
          ),
        data: {
          title: 'Desligamento Profissional - Múltiplo',
          roles: [Role.DESLIGAMENTO_CN_MULTIPLO],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Múltiplo' },
          ],
        },
      },
      {
        path: 'coordenacao/individual',
        loadComponent: () =>
          import('./desligamento-coordenacao/desligamento-individual-form/desligamento-individual-form.component').then(
            (m) => m.DesligamentoIndividualFormComponent,
          ),
        data: {
          title: 'Desligamento Profissional - Individual',
          roles: [Role.DESLIGAMENTO_CN_INDIVIDUAL],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Individual' },
          ],
        },
      },
      {
        path: 'relatorio',
        loadComponent: () =>
          import('./relatorio-desligamento/relatorio-desligamento.component').then(
            (m) => m.RelatorioDesligamentoComponent,
          ),
        data: {
          title: 'Relatório de Desligamento',
          roles: [Role.DESLIGAMENTO_CN_RELATORIO, Role.DESLIGAMENTO_CN_CONSULTAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Relatório de Desligamento' },
          ],
        },
      },
      {
        path: 'relatorio/visualizar',
        loadComponent: () =>
          import('./relatorio-desligamento/relatorio-desligamento-visualizar/relatorio-desligamento-visualizar.component').then(
            (m) => m.RelatorioDesligamentoVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Relatório de Desligamento',
          roles: [Role.DESLIGAMENTO_CN_RELATORIO, Role.DESLIGAMENTO_CN_CONSULTAR],
          breadcrumb: [
            { label: 'Desligamento (Coordenação)', url: '/desligamento-profissional/coordenacao' },
            { label: 'Relatório de Desligamento', url: '/desligamento-profissional/relatorio' },
            { label: 'Visualizar' },
          ],
        },
      },
    ],
  },
];
